//css is clockwise, trigo is anti-clockwise
//rotation is degrees, trigo is radians

export const fromCSSToTrigo = rotation => (Math.abs(rotation) * Math.PI) / 180;
